
import Vue from 'vue';
import { Button } from '@descomplica/vue-components';
import { PostgradTrial, PostgradTrialStatus } from '@/models/postgradTrial/PostgradTrialModel';
import { ChimeraCourseModel } from '@/models/chimera/ChimeraCourseModel';
import Analytics from '@/helpers/analytics';
import { EVENT_LABELS } from '@/helpers/analytics/labels';
import { TrackTrialInteraction } from '@/helpers/analytics/types';
import { CourseModel } from '@descomplica/dex-models';

interface Data {
  displayDays: string;
  displayHours: string;
  displayMinutes: string;
  displaySeconds: string;
  time: any;
}
export default Vue.extend({
  components: {
    Button,
  },
  props: {
    trial: {
      type: Object as Vue.PropType<PostgradTrial>,
      required: true,
    },
  },
  data(): Data {
    return {
      displayDays: '00',
      displayHours: '00',
      displayMinutes: '00',
      displaySeconds: '00',
      time: null,
    };
  },
  computed: {
    clockIconSrc() {
      return `${process.env.BASE_URL}img/icons/clock.svg`;
    },
    currentCourse(): CourseModel {
      return this.$store.getters.currentCourse;
    },
    currentChimeraCourse(): ChimeraCourseModel | null {
      return this.$store.getters.getCurrentChimeraCourse;
    },
    trialStatusByDescomplicaCourseId(): PostgradTrialStatus {
      return this.$store.getters.getTrialStatusByDescomplicaCourseId(
        this.currentChimeraCourse?._id,
      );
    },
    defaultTrackingProps(): TrackTrialInteraction {
      return {
        postgrad_trial: true,
        course: this.currentCourse.name,
        days_remaining: this.trialStatusByDescomplicaCourseId.days_remaining!,
        checkout_url: this.trial.originalCourseCheckoutUrl,
      };
    },
  },
  async mounted() {
    this.time = setInterval(this.updateTimer, 1000);

    Analytics.trackEvent<TrackTrialInteraction>(
      EVENT_LABELS.helloBarViewed,
      this.defaultTrackingProps,
    );
  },
  beforeDestroy() {
    clearInterval(this.time);
  },
  methods: {
    updateTimer() {
      const millisecondsRemaining = this.getRemainingMillisecondsToExpiration();

      if (millisecondsRemaining < 0) {
        clearInterval(this.time);
        return;
      }

      const seconds = Math.floor((millisecondsRemaining % 60000) / 1000);
      const minutes = Math.floor((millisecondsRemaining % 3600000) / 60000);
      const hours = Math.floor((millisecondsRemaining % 86400000) / 3600000);
      const days = Math.floor(millisecondsRemaining / 86400000);

      this.displaySeconds = `0${seconds}`.slice(-2);
      this.displayMinutes = `0${minutes}`.slice(-2);
      this.displayHours = `0${hours}`.slice(-2);
      this.displayDays = `0${days}`.slice(-2);
    },
    redirectToCheckout(): void {
      if (!this.trial.originalCourseCheckoutUrl) return;

      Analytics.trackEvent<TrackTrialInteraction>(
        EVENT_LABELS.buttonClicked,
        this.defaultTrackingProps,
      );

      window.open(this.trial.originalCourseCheckoutUrl, '_blank');
    },
    getRemainingMillisecondsToExpiration() {
      const now = new Date();
      return this.trial.expirationDate.getTime() - now.getTime();
    },
  },
});
